import React from 'react'
import CallToActionButton from 'components/common/CallToActionButton/CallToActionButton'
import { useStyles } from './styles'
import { Show } from 'data/Show'
import clsx from 'clsx'
import moment from 'moment'
import { formatTime } from 'utils/date'

interface ShowCardProps {
    show: Show
    type: 'recent' | 'upcoming'
}

const ShowCard: React.FC<ShowCardProps> = ({ show, type }) => {
    const classes = useStyles()

    return (
        <div
            className={clsx(classes.showCard, {
                [classes.showCardRecent]: type === 'recent',
                [classes.showCardUpcoming]: type === 'upcoming',
            })}
        >
            <div
                className={clsx(classes.showCardContent, {
                    [classes.ticketContent]: type === 'upcoming',
                })}
            >
                <div>
                    <img className={classes.img} src={show.posterImg} alt="" />
                    <h4 className={classes.title}>{show.title}</h4>
                </div>

                <div>
                    {type === 'upcoming' && (
                        <p className={classes.showDateAndTime}>
                            {moment(show.startTime).format('MMM DD')} {formatTime(show.startTime)}
                        </p>
                    )}
                    <CallToActionButton
                        contentClassName={classes.btn}
                        type="secondary"
                        link={{ url: show.path, internal: true }}
                        text={type === 'recent' ? 'Watch Recordings' : 'Reserve Your Spot'}
                        display="block"
                    />
                </div>
                {type === 'upcoming' && <div className={classes.showCardBorder} />}
            </div>
        </div>
    )
}

export default React.memo(ShowCard)
